import "./App.css";
import React from "react";
import DadosAPleno from "./DadosAPleno";

function App() {
  return <DadosAPleno />;
}

export default App;
